/**
 * Portal Manta · KPICard
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, S, FonteBadge } from '../../globals.js';

function KPICard({label, value, unit, sub, fonte, onFonte, color}){
  return (<div style={{...S.cardP, padding:'14px 16px'}}>
    <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',marginBottom:6}}>
      <div style={{fontSize:10.5,fontWeight:600,color:V.g5,textTransform:'uppercase',letterSpacing:.3}}>{label}</div>
      {fonte && <FonteBadge fonte={fonte} onClick={()=>onFonte({fonte, label})}/>}
    </div>
    <div style={{display:'flex',alignItems:'baseline',gap:6}}>
      <div style={{fontSize:22,fontWeight:700,color:color||V.br,letterSpacing:'-0.5px',fontFamily:'monospace'}}>{value}</div>
      {unit && <div style={{fontSize:11,color:V.g4,fontWeight:600}}>{unit}</div>}
    </div>
    {sub && <div style={{fontSize:10,color:V.g4,marginTop:4}}>{sub}</div>}
  </div>);
}

export { KPICard };
export default KPICard;
